import React from "react";
import Cart from "@/features/cart/Cart";
import { getPrimitiveArray, getNumber } from "@/helpers/validation";
import { RecommendedProductProvider } from "@/features/recommended-products";
import { NavData } from "@/features/nav/NavItem";

export interface NavViewProps {
  cartInfo: {
    orderHistoryProductIds: unknown | number[];
  };
  navigationData: {
    leftDesktopNavData: NavData[];
    rightDesktopNavData: NavData[];
    mobileNavData: NavData[];
  };
}

export const NavView = ({ cartInfo }: NavViewProps) => (
  <RecommendedProductProvider
    orderHistoryProductIds={getPrimitiveArray(
      cartInfo.orderHistoryProductIds,
      getNumber
    )}
  >
    <Cart />
  </RecommendedProductProvider>
);
